import React, { useEffect, useState } from 'react'
import type { BomInventory as BomInventoryType } from '@ztechapps/product.common'
import { getBomInventory } from '@ztechapps/product.common'
import { useBillOfMaterialsContext } from './Context'
import { BomProductWidget } from './BomProductWidget'
import type { Product } from '@ztechapps/common.contract'
import sortBy from 'lodash/sortBy'
import { Table } from '@ztechapps/webui.data-tools'
import { UomConversionEquation } from '../QuantityWithUom'

export const BomInventory = () => {
  const [bomInventories, setBomInventories] = useState<BomInventoryType[]>([])
  const { product } = useBillOfMaterialsContext()

  useEffect(() => {
    const bomInventories = getBomInventory(product)

    //convert this to array
    const bomInventoriesArray = Array.from(bomInventories.values())
    //sort by product code
    const sortedBomInventoriesArray = sortBy(bomInventoriesArray, (b) => b.product.code)
    setBomInventories(sortedBomInventoriesArray)
    // `product` covers `productId`/`billOfMaterials` — getBomInventory also reads nested
    // products' inventory quantities under `billOfMaterials`, not just the top-level BOM shape.
  }, [product])

  return (
    <Table
      tableClassName="table table-hover"
      dataArray={bomInventories}
      head={
        <thead>
          <tr className="table-secondary">
            <th style={{ width: '70%' }}>Product</th>
            <th className="text-end">Qty. On Hand</th>
          </tr>
        </thead>
      }
      row={(bomInventory) => {
        const bomProduct = (bomInventory?.product ?? {}) as Product
        return (
          <tr key={bomProduct._id}>
            <td>
              <BomProductWidget {...bomProduct} />
            </td>
            <td className="text-end">
              <UomConversionEquation
                quantity={bomInventory.qtyOnHand}
                symbol={bomProduct?.workOrderUom?.symbol}
                transactionQuantity={bomInventory.baseQtyOnHand}
                transactionSymbol={bomProduct?.baseUom?.symbol}
                decimalPrecision={bomProduct?.unitOfMeasurePrecision ?? 0}
              />
            </td>
          </tr>
        )
      }}
    />
  )
}
